import makeApiCall from "./master/axiosIndex";

export const projectGroupApis = {
  createProjectGroup: (data: any): Promise<any> => {
    return makeApiCall({ url: `/project-group/create`, method: "post", data });
  },
  updateProjectGroup: (data: any): Promise<any> => {
    return makeApiCall({ url: `/project-group/update`, method: "put", data });
  },
  getProjectGroupList: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/project-group/list`,
      method: "get",
      params: data,
    });
  },
  deleteProjectGroup: (data: any): Promise<any> => {
    console.log("data", data);
    return makeApiCall({
      url: `/project-group/delete/${data}`,
      method: "patch",
    });
  },
};
